import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { BackButton } from '../../../components/UI/ComponentsUI';
import { translate } from '../../../utils/util';
import * as actionsStock from '../../../actions/stockAction';

const Home = (props) => {
    const menu = () => {
        let menuItems = [];

        menuItems = [...menuItems, {
            route: {
                pathname: '../stock/search',
                state: {
                    quality: true
                }
            }, icon: 'mdi mdi-clipboard-list-outline', text: translate('stock:query'),
            onClick: () => props.clear()
        }];

        menuItems = [...menuItems, {
            route: {
                pathname: '../stock/drop',
                state: {
                    quality: true,
                    barcode: true,
                    disable: false
                }
            }, icon: 'mdi mdi-arrow-down-bold', text: translate('stock:write-off-by-barcode')
        }];


        menuItems = [...menuItems, {
            route: {
                pathname: '../stock/log',
                state: {
                    quality: true,
                }
            }, icon: 'mdi mdi-file-alert-outline',
            text: translate('delivery:report')
        }];



        return menuItems;

    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-checkbox-multiple-marked-outline" />
                        {translate('stock:quality')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = () => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clear: () => {
            dispatch(actionsStock.clearMaterials());
            dispatch(actionsStock.clearFilter());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(Home))));
